let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5JSTH")).then(() => parcelRequire('1cFLu'));